module.exports = __webpack_public_path__ + "static/media/animated-1.2a5aa037.gif";